var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30695 0.980469C5.4562 0.982652 3.68189 1.71883 2.37321 3.0275C1.06454 4.33618 0.328363 6.11049 0.326179 7.96124C0.323963 9.47367 0.817994 10.9451 1.73249 12.1497C1.73249 12.1497 1.92287 12.4004 1.95397 12.4365L7.30695 18.7497L12.6625 12.4334C12.6904 12.3997 12.8814 12.1497 12.8814 12.1497L12.882 12.1478C13.7961 10.9437 14.2899 9.47297 14.2877 7.96124C14.2855 6.11049 13.5494 4.33618 12.2407 3.0275C10.932 1.71883 9.15769 0.982652 7.30695 0.980469ZM7.30695 10.4997C6.80489 10.4997 6.3141 10.3508 5.89665 10.0719C5.47921 9.79296 5.15385 9.39651 4.96172 8.93266C4.76959 8.46882 4.71932 7.95842 4.81726 7.46601C4.91521 6.9736 5.15697 6.52128 5.51198 6.16627C5.86699 5.81126 6.31931 5.5695 6.81172 5.47155C7.30413 5.3736 7.81453 5.42387 8.27837 5.616C8.74222 5.80814 9.13867 6.1335 9.4176 6.55094C9.69653 6.96839 9.84541 7.45918 9.84541 7.96124C9.84457 8.63422 9.57686 9.2794 9.10098 9.75527C8.62511 10.2311 7.97993 10.4989 7.30695 10.4997Z",
    fill: "#100C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f591d058f48daa390050f05e9707813b.svg";
export { ForwardRef as ReactComponent };